import React, { useEffect, useState } from 'react'
import { ItemsRequestModel } from '.'
import { Skeleton } from '@mui/material'
import WarehousesApp from '../warehouses/WarehousesApp'
import LocationsApp, { ILocationModel } from '../locations/LocationsApp'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'

interface IRequestDestinationAddressProps {
    request: ItemsRequestModel,
    returnAsText?: boolean,
    updateLocation?: (location: ILocationModel) => void,
}

export default function RequestDestinationAddress(props: IRequestDestinationAddressProps) {

    const dispatch = useDispatch()

    const { request, returnAsText, updateLocation } = props

    const [loading, setLoading] = useState<boolean>(true)
    const [address, setAddress] = useState<ILocationModel | null>(null)

    const [locationId, setLocationId] = useState<number | null>(null)

    const warehousesApp = new WarehousesApp()
    const locationsApp = new LocationsApp()

    useEffect(() => {

        if (request.designation_type === "warehouse" && request.destination_warehouse){
            warehousesApp.singleInstanceDetails(request.destination_warehouse)
                .then(response => {
                    setLocationId(response.data.location_id)
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }

        if (request.designation_type === "location" && request.destination_location){
            setLocationId(request.destination_location)
        }

    }, [])

    useEffect(() => {
        if (locationId){
            locationsApp.singleInstanceDetails(locationId)
                .then(response => {
                    setAddress(response.data)
                    setLoading(false)
                    
                    if (updateLocation){
                        updateLocation(response.data)
                    }
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }, [locationId])

    if (loading){
        return <h4><Skeleton variant="text" width={100} /></h4>
    }

    if (!address){
        return <h4>-</h4>
    }

    if (returnAsText){
        return <>{address.address}</>
    }

    return <h4>{address.address}</h4>
}